import { InputSize } from './types';

const LARGE: InputSize = 'large';
const MEDIUM: InputSize = 'medium';
const SMALL: InputSize = 'small';

export const inputSizes = {
  LARGE,
  MEDIUM,
  SMALL,
};
